module.exports = __webpack_public_path__ + "img/sklep-defence-24.c2faf84c.svg";